import { render, staticRenderFns } from "./DashboardBoxCreaGallery.vue?vue&type=template&id=f2263170&scoped=true&"
import script from "./DashboardBoxCreaGallery.vue?vue&type=script&lang=js&"
export * from "./DashboardBoxCreaGallery.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBoxCreaGallery.vue?vue&type=style&index=0&id=f2263170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2263170",
  null
  
)

export default component.exports